import { Text, Stack, Heading } from 'braid-design-system';

interface Props {
  title: string;
  cardTitle: string;
  body: string;
}

const Confirmation = ({ title, cardTitle, body }: Props) => (
  <Stack space="medium">
    <Heading level="2" component="h1">
      {title}
    </Heading>

    <Stack space="small">
      <Text>{cardTitle}</Text>
      <Text>{body}</Text>
    </Stack>
  </Stack>
);

export default Confirmation;
